import initialState from '../store/initial-state'
import {
  ASSET_CONFIRM_GET_DATA,
  ASSET_CONFIRM_GET_DATA_SUCCESS,
  ASSET_CONFIRM_GET_DATA_FAILURE,
  ASSET_CONFIRM_EDIT,
  ASSET_CONFIRM_EDIT_SUCCESS,
  ASSET_CONFIRM_EDIT_FAILURE,
  ASSET_CONFIRM_EMPTY,
  ASSET_CONFIRM_DELETE,
  ASSET_CONFIRM_DELETE_SUCCESS,
  ASSET_CONFIRM_DELETE_FAILURE,
  ASSET_CONFIRM_EXISTS_SUCCESS,
  ASSET_CONFIRM_EXISTS_FAILURE,
  ASSET_CONFIRM_ADD_TAGS,
  ASSET_CONFIRM_CHANGE_COPYRIGHT,
  ASSET_CONFIRM_CHANGE_NAME,
  ASSET_CONFIRM_MOVE_FOLDER,
  ASSET_CONFIRM_MOVE_FOLDER_SUCCESS,
  ASSET_CONFIRM_MOVE_FOLDER_FAILURE,
  ASSET_CONFIRM_UPDATE_FROM_PERMISSION,
  ASSET_BY_CONFIRM,
} from '../constants/assets-confirm-types'

export default (state = initialState.assetsConfirm, action) => {
  switch (action.type) {
    case ASSET_CONFIRM_GET_DATA:
      return {
        ...state,
        isFetching: true,
        data: [],
        error: null
      }

    case ASSET_CONFIRM_GET_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
        headers: action.payload.headers,
        page: action.payload.page,
        error: null
      }

    case ASSET_CONFIRM_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: [],
        error: action.payload
      }

    case ASSET_CONFIRM_EDIT:
      return {
        ...state,
        isUpdating: true,
        error: null
      }

    case ASSET_CONFIRM_EDIT_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        data: [...state.data.filter(r => r._id !== action.payload.id)],
        error: null
      }

    case ASSET_CONFIRM_EDIT_FAILURE:
      return {
        ...state,
        headers: null,
        isUpdating: false,
        error: action.payload
      }

    case ASSET_CONFIRM_EMPTY:
      return {
        ...state,
        folderselect: null,
        isFetching: true,
        isUpdating: false,
        data: [],
        headers: [],
        error: null
      }

    case ASSET_CONFIRM_DELETE:
      return {
        ...state,
        isDeleting: true
      }

    case ASSET_CONFIRM_DELETE_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        data: [...state.data.filter(r => r._id !== action.payload.id)],
        error: null
      }

    case ASSET_CONFIRM_DELETE_FAILURE:
      return {
        ...state,
        isDeleting: false,
        error: action.payload.error
      }

    case ASSET_CONFIRM_EXISTS_SUCCESS:
      return {
        ...state,
        existsConfirm: action.payload,
        existsConfirmIsFailed: false
      }

    case ASSET_CONFIRM_EXISTS_FAILURE:
      return {
        ...state,
        existsConfirm: false,
        existsConfirmIsFailed: true
      }

    case ASSET_CONFIRM_ADD_TAGS:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            metadata: {
              ...r.metadata,
              descriptiveTags: r._id === action.payload.asset._id
                ? action.payload.newTag
                : r.metadata.descriptiveTags,
            }
          }
        })]
      }

    case ASSET_CONFIRM_CHANGE_COPYRIGHT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            metadata: {
              ...r.metadata,
              createdDate: r._id === action.payload.asset._id
                ? action.payload.copyright.copyright.createDate
                : r.metadata.createdDate,
              dueDate: r._id === action.payload.asset._id
                ? action.payload.copyright.copyright.dueDate
                : r.metadata.dueDate,
            }
          }
        })]
      }

    case ASSET_CONFIRM_CHANGE_NAME:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            name: r._id === action.payload.asset._id
              ? action.payload.name
              : r.name
          }
        })]
      }

    case ASSET_CONFIRM_MOVE_FOLDER:
      return {
        ...state,
        isMoving: true,
        status: ''
      }

    case ASSET_CONFIRM_MOVE_FOLDER_SUCCESS:
      return {
        ...state,
        isMoving: false,
        status: 'success'
      }

    case ASSET_CONFIRM_MOVE_FOLDER_FAILURE:
      return {
        ...state,
        isMoving: false,
        status: 'failure'
      }

    case ASSET_CONFIRM_UPDATE_FROM_PERMISSION:
      return {
        ...state,
        data: [
          ...state.data.map(r => {
            return r._id === action.payload._id
              ? action.payload
              : { ...r }
          })
        ]
      }

    case ASSET_BY_CONFIRM:
      return {
        ...state,
        confirmAssetsBy: action.payload
      }

    default: return { ...state }
  }
}